// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__2-7Ij","main":"Home_main__3xWYT","results":"Home_results__2QWdf","input":"Home_input__1I3Zq"};